import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { ChartAttributeName } from "utlis/utils";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { capitalize } from "lodash";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const FONT_FAMILY = "Montserrat";
const FONT_SIZE = 20;
const FONT_WEIGHT = 600;
const COLORS = [
  "#4B006D",
  "#814D99",
  "#231A3D",
  "#4B006D",
  "#231A3D",
  "#814D99",
  "#231A3D",
  "#814D99",
];

const relationColorMapping = {
  "self": "#372B5A",
  "spouse": "#4E3F77",
  "son": "#675794",
  "daughter": "#8271B2",
  "father": "#9F8FCF",
  "mother": "#BFAFEC",
  "fatherinlaw": "#E4DAFF", 
  "motherinlaw": "#D8CBFF",
  
  // Age band colors
  "0-20": "#9F8FCF",
  "20-40": "#814D99",
  "40-60": "#241a3d",
  "60+": "#4B006D"
} 

const getColor = (input) => {
  if (typeof input === "number") {
    return COLORS.slice(0, input);
  }
  return COLORS[input % COLORS.length];
};

const BaseDoughnutChart = ({ labels, datasets, title, radius, cutout }) => {

const chartConfig = useMemo(() => {
    // Map each label to its corresponding color from relationColorMapping
    const backgroundColors = labels.map((label, index) => {
      const key = label?.toString().toLowerCase().trim();
      return relationColorMapping[key] || COLORS[index % COLORS.length];
    });

    const chartDatasets = Object.keys(datasets).map((key) => ({
      label: " Count",
      backgroundColor: backgroundColors,
      data: datasets[key],
    }));

    const labelColorHandler = (labelValue) => {
      return relationColorMapping[labelValue]
    }

    return {
      data: {
        labels: labels.map((label) => capitalize(label)),
        datasets: chartDatasets,
      },
      options: {
        cutout: cutout || 70,
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
        plugins: {
          title: {
            display: true,
            text: title,
            align: "start",
            font: {
              family: FONT_FAMILY,
              weight: FONT_WEIGHT,
              size: FONT_SIZE,
            },
            padding: {
              top: 12,
              bottom: 24,
            },
            color: "#30301B",
          },
          legend: {
            display: true,
            position: "right",
            align: "center",
            labels: {
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
              pointStyle: "circle",
              font: {
                family: FONT_FAMILY,
                size: 12,
                weight: 400,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
          datalabels: {
            display: true,
            formatter: (value, context) => {
              const dataset = context.dataset.data;
              const total = dataset.reduce((acc, val) => acc + val, 0);
              const percentage = ((value / total) * 100).toFixed(1);
              if(percentage === "0.0") return "";
              return `${percentage}%`;
            },
            color: "#fff",
            font: {
              family: FONT_FAMILY,
              size: 12,
              weight: 400,
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        radius: radius || "100%"
      },
    };
  }, [labels, datasets, title]);

  return (
    <Doughnut
      data={chartConfig.data}
      options={chartConfig.options}
      plugins={[ChartDataLabels]}
    />
  );
};

export default BaseDoughnutChart;
